// extracted by mini-css-extract-plugin
export var buttons = "f_Y";
export var editor = "f_X";
export var textBox = "f_Z";
export var toast = "f_0";
export var userOptions = "f_1";